import React, { useState, useEffect } from "react";
import {
  DataGrid,
  GridActionsCellItem,
  GridDeleteIcon,
} from "@mui/x-data-grid";
import ConfirmationModal from "../confirmation-modal/ConfirmationModal";
import SuccessAlert from "../success-alert/SuccessAlert";
import ErrorAlert from "../error-alert/ErrorAlert";
import { API, SERVER_DOMAIN } from "../../assets/staticData";
import { Switch } from "@mui/material";

export default function LanguagesDataTable({ data, user }) {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [confirmed2, setConfirmed2] = useState(false);
  const [clickedEntryId, setClickedEntryId] = useState();
  const [selected, setSelected] = useState([]);
  const [deleteSelected, setDeleteSelected] = useState(false);
  const [checks, setChecks] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);

  let userToken = localStorage.getItem("userToken");

  const headers = {
    Authorization: `Bearer ${userToken}`,
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "icon",
      headerName: "Icon",
      width: 130,
      renderCell: (params) => (
        <img
          src={params.value}
          style={{
            height: "60%",
            aspectRatio: 1,
            borderRadius: 25,
            marginTop: "9%",
            objectFit: "cover",
          }}
        />
      ),
    },
    { field: "language", headerName: "Language", width: 150 },
    {
      field: "date",
      headerName: "Date",
      width: 130,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      cellClassName: "actions",
      width: 130,
      getActions: ({ id }) => {
        return [
          <Switch
            disabled={!user.perms[0]?.edit}
            size="small"
            checked={checks.find((check) => check.id === id)?.active || false}
            onChange={() => handleSwitchToggle(id)}
          />,

          <>
            {user.perms[0].delete && (
              <GridActionsCellItem
                style={{ display: user.perms[0]?.delete ? null : "none" }}
                icon={<GridDeleteIcon />}
                label="Delete"
                onClick={handleDeleteClick(id)}
              />
            )}
          </>,
        ];
      },
    },
  ];

  const handleDeleteClick = (id) => () => {
    setOpen(true);
    setClickedEntryId(id);
  };

  const handleSwitchToggle = async (id) => {
    const itemIndex = checks.findIndex((check) => check.id === id);
    if (itemIndex > -1) {
      const updatedChecks = [...checks];
      const newActiveStatus = !updatedChecks[itemIndex].active;
      updatedChecks[itemIndex].active = newActiveStatus;
      setChecks(updatedChecks);

      try {
        // Update the active status on the server
        await fetch(`${API}/languages/${id}`, {
          method: "PUT",
          headers: {
            ...headers,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ data: { active: newActiveStatus } }),
        });
      } catch (error) {
        console.error("Error updating active status:", error);
        setFail(true);
      }
    }
  };

  useEffect(() => {
    async function deleteEntry() {
      if (confirmed == true) {
        fetch(`${API}/languages/${clickedEntryId}`, {
          headers,
          method: "DELETE",
        }).then(async (res) => {
          if (res.ok) {
            setSuccess(true);
            setRows(rows.filter((row) => row.id !== clickedEntryId));
            setConfirmed(false);
          } else {
            setFail(true);
            setConfirmed(false);
          }
        });
      }
    }

    deleteEntry();
  }, [confirmed]);

  useEffect(() => {
    let docs = [];
    let checksDocs = [];
    data?.forEach((item) => {
      docs.push({
        id: item.id,
        language: item.attributes.language,
        date: new Date(item.attributes.createdAt).toLocaleDateString("tr-TR"),
        icon: item.attributes?.icon?.data?.attributes?.url
          ? `${SERVER_DOMAIN + item.attributes.icon.data.attributes.url}`
          : "",
      });

      checksDocs.push({
        id: item.id,
        active: item.attributes.active,
      });
    });

    setRows(docs);
    setChecks(checksDocs);
  }, [data]);

  const deleteSelectedItems = async () => {
    setOpen2(true);
  };

  useEffect(() => {
    async function deleteSelected() {
      if (confirmed2 == true) {
        setDeleteSelected(false);
        try {
          await Promise.all(
            selected.map(async (item) => {
              await fetch(`${API}/languages/${item}`, {
                headers,
                method: "DELETE",
              });
            })
          );

          const updatedRows = rows.filter((row) => !selected.includes(row.id));
          setRows(updatedRows);
          setSelected([]);
          setSuccess(true);
        } catch (error) {
          console.error("Error deleting items:", error);
        }
      }
    }

    deleteSelected();
  }, [confirmed2]);

  return (
    <div style={{ width: "100%" }}>
      <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
      <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
      <DataGrid
        sx={{ minHeight: 580 }}
        disableColumnSorting
        disableAutosize
        disableColumnFilter
        onRowSelectionModelChange={(v) => {
          setSelected(v);
          if (v.length > 0) {
            setDeleteSelected(true);
          } else {
            setDeleteSelected(false);
          }
        }}
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20, 30]}
        checkboxSelection
      />
      {deleteSelected && user.perms[0].delete && (
        <div onClick={deleteSelectedItems} className="deleteBTN">
          Delete Selected Items
        </div>
      )}
      <ConfirmationModal
        message={"Are you sure you want to delete this item?"}
        open={open}
        setOpen={setOpen}
        setConfirmed={(v) => setConfirmed(v)}
      />
      <ConfirmationModal
        message={"Are you sure you want to delete the selected items?"}
        open={open2}
        setOpen={setOpen2}
        setConfirmed={(v) => setConfirmed2(v)}
      />
    </div>
  );
}
